import collapse from "../modules/collapse.js";

const faqItems = document.querySelectorAll(".faq-item");
const loadMoreBtn = document.getElementById("load-more-faq");

faqItems.forEach((item) => {
  const trigger = item.querySelector(".faq-item-trigger"),
    content = item.querySelector(".faq-item-content");

  trigger.addEventListener("click", () => {
    if (!item.classList.contains("-active")) {
      collapse(content);
      item.classList.add("-active");
    } else {
      collapse(content);
      item.classList.remove("-active");
    }
  });
});

if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", () => {
    const hiddenItems = document.querySelectorAll(".faq-item.hidden");
    hiddenItems.forEach((item) => {
      item.classList.remove("hidden");
    });
    loadMoreBtn.style.display = "none";
  });
}
